import React from "react";
import { useHistory } from 'react-router-dom';
import axios from "axios";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons
import PersonIcon from '@material-ui/icons/Person';
import LockIcon from '@material-ui/icons/Lock';

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";

import SimpleError from "views/component/SimpleError.js";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

const useStyles = makeStyles(styles);

export default function Login() {
  const history = useHistory();

  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  const [userId, setIdState] = React.useState("");
  const [password, setPasswordState] = React.useState("");
  const [errorShow, setErrorShow] = React.useState(false);

  const verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };

  const loginButtonClick = function () {
    if(userId === "") {
      setIdState("error");
    }
    if(password === "") {
      setPasswordState("error");
    }

    if(userId !== "error" && password !== "error" && userId !== "" && password !== "") {
      axios.post('data/user/login', { 'userId': userId, 'password': password })
          .then(response => {
              if (response.data.userId) {
                // 로그인 성공 시 response id: id, password: ""
                window.sessionStorage.setItem('userId', response.data.userId);
                window.sessionStorage.setItem('projectList', response.data.projectList);
                window.sessionStorage.setItem('isAdmin', response.data.admin);
                history.push('/project/main');
              } else {
                // 로그인 실패 시 response id: null, password: null
                setErrorShow(true);
              }
          });
      setErrorShow(false);
    } else {
      setErrorShow(true);
    }
  };

  const signUpButtonClick = function () {
    history.push('/user/signup');
  };

  const enterKeyPress = function (event) {
    if(event.key === "Enter") {
      loginButtonClick();
    }
  };

  const onConfirm = function () {
    setErrorShow(false);
  }

  React.useEffect(() => {
    let id = setTimeout(function() {
      setCardAnimation("");
    }, 700);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.clearTimeout(id);
    };
  });

  const classes = useStyles();
  return (
    <div className={classes.container}>
      <SimpleError show={errorShow} title="로그인 정보를 확인해주세요" onConfirm={onConfirm}/>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form>
              <Card login className={classes[cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="info"
                >
                  <h4 className={classes.cardTitle}>FACTORY DOCTOR</h4>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    error={userId === "error"}
                    labelText="id"
                    id="userId"
                    underlineColor="info"
                    onKeyPress={enterKeyPress}
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <PersonIcon className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      onChange: event => {
                        if(verifyLength(event.target.value, 1)) {
                          setIdState(event.target.value);
                        } else {
                          setIdState("error");
                        }
                      },
                      type: "text",
                      autoComplete: "off"
                    }}
                  />
                  <CustomInput
                    error={password === "error"}
                    labelText="Password"
                    id="password"
                    underlineColor="info"
                    onKeyPress={enterKeyPress}
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <LockIcon className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      onChange: event => {
                        if(verifyLength(event.target.value, 1)) {
                          setPasswordState(event.target.value);
                        } else {
                          setPasswordState("error");
                        }
                      },
                      type: "password",
                      autoComplete: "off"
                    }}
                  />
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                <Button color="info" size="lg" onClick={loginButtonClick} className={classes.registerButton}>
                    LOG IN
                  </Button>
                </CardFooter>
                <CardFooter className={classes.justifyContentCenter}>
                  <Button color="success" simple size="sm" onClick={signUpButtonClick}>
                      sign up
                  </Button>
                </CardFooter>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
    </div>
  );
}
